export class AbortableFetcher {
    private controllers: AbortController[] = [];

    public fetch = async (input: string, init: RequestInit & { timeout?: number } = {}) => {
        const controller = new AbortController();

        const timeout = setTimeout(() => controller.abort(), init?.timeout ?? 30000);

        this.controllers.push(controller);

        const result = await fetch(input, { ...init, signal: controller.signal });

        clearTimeout(timeout);

        return result;
    };

    public abort() {
        for (const controller of this.controllers) {
            controller.abort();
            this.controllers.length = 0;
        }
    }
}
